import React from 'react';

import Box from './styles.js';

const Mensaje = ({ imagen, titulo, parrafo, finBold, color }) => {

  return (
    <Box>
         <section className="mensaje-error" style={{backgroundColor: color}}>
         <div className="contenedor-mensaje-error">
           <img src={imagen} alt="error-img" />
           <hgroup>
             <p className="strong">{titulo}</p>
             <p>{parrafo} <strong>{finBold}</strong></p>
           </hgroup>
         </div>
       </section>
     
    </Box>
  )
}

export default Mensaje;